module.exports = __webpack_public_path__ + "img/index-section6-friend2.5e426b40.svg";